import React, { useState } from 'react';
import { Table, Button, Checkbox, Space, Card, Popconfirm, Flex, Form, notification, Modal, Select, Input, DatePicker } from 'antd';
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import moment from 'moment';
import axios from 'axios';

const PromoCodeReportTable = ({ data = [], isToView, onDeactivate, couponsWithoutPromo, fetchPromoCodes }) => {
    const [createModalVisible, setCreateModalVisible] = useState(false);
    const [form] = Form.useForm();
    const [isCreating, setIsCreating] = useState(false);

    console.log("PromoCodeReportTable data:", data);
    // Create new promo code
    const handleCreatePromoCode = async (values) => {
        try {
            setIsCreating(true);
            const payload = {
                couponId: values.couponId,
                code: values.code.toUpperCase(),
                expiresAt: values?.expiresAt?.format('YYYY-MM-DD'),
                restrictNewCustomer: values?.restrictNewCustomer,
                // discountAmount: values.discountAmount,
                // discountType: values.discountType || 'percentage', // percentage or fixed
                // description: values.description || '',
            };

            const response = await axios.post('/api/promo/create', payload);

            if (response.data.success) {
                notification.success({
                    message: 'Success',
                    description: 'Promo code created successfully!',
                    placement: 'topRight',
                    duration: 3,
                });

                setCreateModalVisible(false);
                form.resetFields();
                fetchPromoCodes(); // Refresh the list
            } else {
                throw new Error(response.data.message || 'Failed to create promo code');
            }
        } catch (error) {
            console.error('Error creating promo code:', error);
            notification.error({
                message: 'Error',
                description: error.response?.data?.message || 'Failed to create promo code. Please try again.',
                placement: 'topRight',
                duration: 5,
            });
        } finally {
            setIsCreating(false);
        }
    };

    const handleToggleActive = async (record) => {
        debugger
        const promoId = record.promoId;
        const makeActive = !record.active;


            try {
                const response = await axios.post('/api/promo/deactivate', {
                    promoId,
                    active: makeActive
                });

                if (response.data.success) {
                    notification.success({
                        message: 'Success',
                        description: `Promo code ${makeActive ? 'activated' : 'deactivated'} successfully!`,
                        placement: 'topRight',
                        duration: 3,
                    });

                    fetchPromoCodes();
                } else {
                    throw new Error(response.data.message || 'Failed to update promo code');
                }
            } catch (error) {
                console.error('Error updating promo code:', error);
                notification.error({
                    message: 'Error',
                    description: error.response?.data?.message || 'Failed to update promo code. Please try again.',
                    placement: 'topRight',
                    duration: 5,
                });
            }
    }

    const columns = [
        {
            title: '🎫',
            dataIndex: 'code',
            key: 'codeIcon',
            width: 60,
            align: 'center',
            render: () => <span style={{ fontSize: '16px' }}>🎫</span>
        },
        {
            title: 'Promo Code',
            dataIndex: 'code',
            key: 'code',
            width: 120,
            render: (text) => <strong style={{ color: '#1890ff' }}>{text}</strong>
        },
        {
            title: 'Discount',
            dataIndex: 'discountAmount',
            key: 'discount',
            width: 100,
            render: (amount, record) => {
                const { discountType } = record;

                if (discountType === 'percentage') {
                    return `${amount}%`;  // amount is already percent
                } else {
                    // Stripe returns cents, so convert
                    const discount = amount / 100;
                    return `$${discount.toFixed(2)}`;
                }
            }
        },
        {
            title: 'Type',
            dataIndex: 'discountType',
            key: 'discountType',
            width: 80,
            render: (type) => type === 'percentage' ? 'Percentage' : 'Fixed Amount'
        },
        {
            title: 'Expiration Date',
            dataIndex: 'expirationDate',
            key: 'expirationDate',
            width: 120,
            render: (date) => {
                const isExpired = moment(date).isBefore(moment());
                return (
                    <span style={{ color: isExpired ? '#ff4d4f' : '#52c41a' }}>
                        {moment(date).format('MMM DD, YYYY')}
                    </span>
                );
            }
        },
        {
            title: 'Status',
            dataIndex: 'active',
            key: 'status',
            width: 80,
            render: (active) => (
                <span style={{
                    color: active ? '#52c41a' : '#ff4d4f',
                    fontWeight: 'bold',
                    padding: '2px 8px',
                    borderRadius: '4px',
                    backgroundColor: active ? '#f6ffed' : '#fff2f0',
                    border: `1px solid ${active ? '#b7eb8f' : '#ffccc7'}`
                }}>
                    {active ? 'Active' : 'Inactive'}
                </span>
            )
        },
        {
            title: 'Used Count',
            dataIndex: 'usedCount',
            key: 'usedCount',
            width: 100,
            render: (count) => count || 0
        },
        {
            title: 'Created Date',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 120,
            render: (date) => moment(date).format('MMM DD, YYYY')
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            width: 150,
            render: (text) => text || 'No description'
        },
        {
            title: 'Action',
            key: 'action',
            width: 120,
            fixed: 'right',
            render: (_, record) => (
                <Space size="small">
                    {isToView && (
                        <Popconfirm
                            title={`Are you sure you want to ${record.active ? 'deactivate' : 'activate'} this promo code?`}
                            description="This action can be reversed later."
                            onConfirm={() => handleToggleActive(record)}
                            okText="Yes"
                            cancelText="Cancel"
                        >
                            <Button
                                type="primary"
                                size="small"
                                style={{
                                    backgroundColor: record.active ? 'rgb(206, 46, 40)' : 'rgb(0, 128, 0)',
                                    borderColor: record.active ? 'rgb(206, 46, 40)' : 'rgb(0, 128, 0)',
                                    fontSize: '11px',
                                    height: '24px',
                                    padding: '0 8px'
                                }}
                            >
                                {record.active ? 'Deactivate' : 'Activate'}
                            </Button>
                        </Popconfirm>
                    )}
                </Space>
            )
        }
    ];
    const tableData = data.length > 0 ? data : [];

    // Calculate stats
    const activeCount = tableData.filter(item => item.active).length;
    const expiredCount = tableData.filter(item => moment(item.expirationDate).isBefore(moment())).length;
    const usedCount = tableData.filter(item => (item.usedCount || 0) > 0).length;

    return (
        <div style={{ padding: '20px', backgroundColor: '#f5f5f5' }}>
            <Flex justify='flex-end' align="flex-end" style={{ width: '100%', marginBottom: 10 }}>
                <Button

                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => setCreateModalVisible(true)}
                    size="large"
                    style={{ backgroundColor: 'black', borderColor: 'black' }}
                >
                    Create New Promo Code
                </Button>

            </Flex>

            <Card
                style={{
                    borderRadius: '8px',
                    overflow: 'hidden',
                    border: '2px solid #ccc'
                }}
                bodyStyle={{ padding: 0 }}
            >
                {/* Header */}
                <div style={{
                    backgroundColor: 'rgb(206, 46, 40)',
                    color: 'white',
                    padding: '12px 20px',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    textAlign: 'center'
                }}>
                    Promo Code Management
                </div>

                {/* Status Bar */}
                <div style={{
                    backgroundColor: '#e8e8e8',
                    padding: '12px 20px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid #ddd'
                }}>
                    <span style={{ fontWeight: 'bold' }}>
                        Total Codes: <span style={{ fontWeight: 'normal' }}>{tableData.length}</span>
                    </span>
                    <Space size="large">
                        {/* <span style={{ fontWeight: 'bold' }}>Status:</span> */}
                        {/* <Checkbox
                            checked={activeCount > 0}
                            style={{
                                '& .ant-checkbox-checked .ant-checkbox-inner': {
                                    backgroundColor: 'green',
                                    borderColor: 'green'
                                }
                            }}
                        >
                            <span>Active ({activeCount})</span>
                        </Checkbox>
                        <Checkbox
                            checked={expiredCount > 0}
                            style={{
                                '& .ant-checkbox-checked .ant-checkbox-inner': {
                                    backgroundColor: 'orange',
                                    borderColor: 'orange'
                                }
                            }}
                        >
                            <span>Expired ({expiredCount})</span>
                        </Checkbox>
                        <Checkbox
                            checked={usedCount > 0}
                            style={{
                                '& .ant-checkbox-checked .ant-checkbox-inner': {
                                    backgroundColor: 'blue',
                                    borderColor: 'blue'
                                }
                            }}
                        >
                            <span>Used ({usedCount})</span>
                        </Checkbox> */}
                    </Space>
                </div>

                {/* Table */}
                <Table
                    dataSource={tableData}
                    columns={columns}
                    rowKey="_id"
                    pagination={{
                        pageSize: 10,
                        showSizeChanger: false,
                        showQuickJumper: false,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} promo codes`,
                        style: { padding: '16px 20px' }
                    }}
                    scroll={{ x: 'max-content' }}
                    size="small"
                    style={{
                        '& .ant-table-thead > tr > th': {
                            backgroundColor: 'rgb(206, 46, 40)',
                            color: 'white',
                            fontWeight: 'bold',
                            fontSize: '12px',
                            padding: '8px 12px'
                        },
                        '& .ant-table-tbody > tr > td': {
                            fontSize: '11px',
                            padding: '8px 12px'
                        }
                    }}
                />
            </Card>
            {/* Create Promo Code Modal */}
            <Modal
                title="Create New Promo Code"
                open={createModalVisible}
                onCancel={() => {
                    setCreateModalVisible(false);
                    form.resetFields();
                }}
                footer={null}
                width={600}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleCreatePromoCode}
                    requiredMark={false}
                >

                    {/* Coupon Selection */}
                    <Form.Item
                        label="Select Coupon Campaign"
                        name="couponId"
                        rules={[{ required: true, message: 'Please select a coupon!' }]}
                    >
                        <Select
                            placeholder="Choose a coupon"
                            // loading={loadingCoupons}
                            showSearch
                            optionFilterProp="children"
                        >
                            {couponsWithoutPromo?.map(coupon => (
                                <Select.Option key={coupon.id} value={coupon.id}>
                                    {coupon.name || coupon.id} —{" "}
                                    {/* {coupon.percent_off
                      ? `${coupon.percent_off}% OFF`
                      : `$${coupon.amount_off / 100} OFF`}{" "}
                    ({coupon.duration}) */}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    {/* Promo Code */}

                    <Form.Item
                        label="Promo Code"
                        name="code"
                        rules={[
                            { required: true, message: 'Please enter a promo code!' },
                            { min: 3, message: 'Promo code must be at least 3 characters!' },
                            { max: 20, message: 'Promo code cannot exceed 20 characters!' },
                            { pattern: /^[A-Za-z0-9]+$/, message: 'Only letters and numbers allowed!' }
                        ]}
                    >
                        <Input
                            placeholder="Enter promo code (e.g., SAVE20)"
                            style={{ textTransform: 'uppercase' }}
                            onChange={(e) => {
                                const upperValue = e.target.value.toUpperCase();
                                form.setFieldsValue({ code: upperValue });
                            }}
                        />
                    </Form.Item>

                    {/* Expiration Date */}
                    <Form.Item
                        label="Expiration Date"
                        name="expiresAt"
                        rules={[
                            { required: true, message: 'Please select an expiration date!' }
                        ]}
                    >
                        <DatePicker
                            style={{ width: '100%' }}
                            disabledDate={(current) => current && current < moment().startOf('day')}
                            placeholder="Select expiration date"
                        />
                    </Form.Item>

                    {/* Restriction: Only New Customers */}
                    <Form.Item
                        name="restrictNewCustomer"
                        valuePropName="checked"
                        initialValue={false}
                    >
                        <Checkbox>Restrict to new customers only</Checkbox>
                    </Form.Item>

                    {/* Actions */}
                    <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
                        <Space>
                            <Button

                                onClick={() => {
                                    setCreateModalVisible(false);
                                    form.resetFields();
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                style={{ backgroundColor: 'black', borderColor: 'black' }}
                                type="primary"
                                htmlType="submit"
                                loading={isCreating}
                            >
                                Create Promo Code
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Modal>
            <style jsx>{`
        .ant-table-thead > tr > th {
          background-color: rgb(206, 46, 40) !important;
          color: white !important;
          font-weight: bold !important;
          font-size: 12px !important;
          padding: 8px 12px !important;
          border-bottom: 1px solid rgb(206, 46, 40) !important;
        }
        .ant-table-tbody > tr > td {
          font-size: 14px !important;
          padding: 8px 12px !important;
        }
        .ant-table-tbody > tr:nth-child(even) {
          background-color: #fafafa !important;
        }
        .ant-checkbox-checked .ant-checkbox-inner {
          background-color: green !important;
          border-color: green !important;
        }
        .ant-checkbox:hover .ant-checkbox-inner,
        .ant-checkbox-input:focus + .ant-checkbox-inner {
          border-color: green !important;
        }
      `}</style>
        </div>
    );
};

export default PromoCodeReportTable;